import {mergeProperties} from "../components/Utility";
import moment from "moment-timezone";

const timezone = 'Asia/Kolkata';
export const getFormData = (data) => {
    const initialData = {
        transactionType: '',
        transactionDate: '',
        amount: '',
        description: '',
    };
    return mergeProperties(initialData, data);
};

export const getTableColumns = ({ActionDropdown, deleteHandler}) => {
    let tableColumns = [
        {header: "Transaction Type", field: "transactionType"},
        {header: "Transaction Date", field: "transactionDate"},
        {header: "Amount", field: "amount"},
        {header: "Description", field: "description"},
    ];

    tableColumns.push({
        header: "Action",
        disableSorting: true,
        field: "action",
        align: "right",
        render: (row) => <ActionDropdown row={row} onDelete={deleteHandler}/>,
    });

    return tableColumns;
};

export const getTableData = ({items = [], list}) => {
    if (!Array.isArray(items)) return [];
    const {
        items: notApplicableList,
        status: notApplicableListStatus,
    } = list.notApplicable;

    return items.map((item) => ({
        id: item.id,
        transactionType: notApplicableListStatus === "success" ? notApplicableList[item.transactionType] : "-",
        transactionDate: moment(item.transactionDate).tz(timezone).format('MMM DD, YYYY, hh:mm A'),
        amount: item.amount,
        description: item.description,
    }));
};

export const getDetailData = ({item, list}) => {
    if (!item) return {details: {}};
    const {
        items: notApplicableList,
        status: notApplicableListStatus,
    } = list.notApplicable;

    return {
        details: {
            id: item.id,
            transactionType: notApplicableListStatus === "success" ? notApplicableList[item.transactionType] : "-",
            transactionDate: moment(item.transactionDate).tz(timezone).format('MMM DD, YYYY, hh:mm A'),
            amount: item.amount,
            description: item.description,
        },
    };
};
